import { useEffect, useState } from "react";

/**
 * Reactive media-query hook. Returns whether `query` currently matches and
 * re-renders when the match state changes (resize, rotation). The SPA is
 * always client-rendered, but the initial read is guarded so it stays safe if
 * ever evaluated without a window.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () =>
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia(query).matches,
  );

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** Phone-width breakpoint used by the dashboard layouts. */
export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 680px)");
}
